import React from 'react'

import { Button } from '@frame/ui-primitives/button'

import { DataAttribute } from '@frame/types'

import { LoadingSpinner } from './loading-spinner'

type Props = {
  completeSession: () => Promise<void>
  isCompletingSession?: boolean
  hasOnlyInstantEmployments?: boolean
}

export function ButtonGroup({
  completeSession,
  isCompletingSession = false,
  hasOnlyInstantEmployments = false,
}: Props) {
  async function handleClick() {
    await completeSession()
  }

  return {
    primary: (
      <Button
        data-cy={DataAttribute.BTN_SUBMIT_EMPLOYER_HISTORY}
        Icon={isCompletingSession ? LoadingSpinner : undefined}
        disabled={isCompletingSession}
        onClick={handleClick}
        applyCobranding
        intent={hasOnlyInstantEmployments ? 'secondary' : 'primary'}
      >
        I'm done, submit
      </Button>
    ),
  }
}
